import UserSettings from "../components/UserSettings";
import TeamSettings from "../components/TeamSettings";

export const hiddenRoutes = [
  {
    path: "/user",
    Component: UserSettings,
  },
  {
    path: "/team",
    Component: TeamSettings,
  },
];
